
















import Vue from 'vue'
import { imagePlaceholderProduct } from '~/common';
import SfCardHorizontal from "~/themes/fiskarsMoominDefault/components/components/molecules/SfCardHorizontal/SfCardHorizontal.vue";
import {checkIfUrlIsExternal} from "~/helpers/validation-utils";
export default Vue.extend({
  name: 'CardHorizontal',
  components: {
    SfCardHorizontal
  },
  methods: {
    getCardBackgroundColor(backgroundObj) {
      return backgroundObj?.background?.selectionValues[0]?.key;
    },
    getLayout(layoutObj) {
      return layoutObj?.selectionValues[0]?.key?.toLowerCase();
    },
    checkAndReturnLink(link) {
      if(!link) return "/";

      if(checkIfUrlIsExternal(link)) {
        return link;
      } else {
        return this.localePath(link);
      }
    }
  },
    props: {
      image: {
        type: Object,
        default: () => {
          return {
            desktop: imagePlaceholderProduct,
            mobile: imagePlaceholderProduct,
            thumbnail: imagePlaceholderProduct,
            alt: "image"
          }
        }
      },
      imageUrl: {
        type: String,
        default: "",
      },
      title: {
        type: String,
        default: "",
      },
      titleLevel: {
        type: [Number, String],
        default: 5,
      },
      description: {
        type: String,
        default: "",
      },
      link: {
        type: [Object, String],
        default: "",
      },
      buttonText: {
        type: String,
        default: "Read more",
      },
      linkUrlsecondary: {
        type: String,
        default: "",
      },
      secondaryButtonText: {
        type: String,
        default: "View details",
      },
      background: {
        type: Object,
        default: () => {
          return {
            "background": { "sourceName": null, "selectionValues": [ { "key": "var(--c-secondary)", "label": "Turquoise" } ] }
          }
         },
      },
      subtitle: {
        type: String,
        default: "",
      },
      layout: {
        type: Object,
      }
  },
})
